// Angular
import { Component, Input, OnChanges } from '@angular/core';

// Afidium
import { ISummarySectorAir } from '../../../sectors/components/shared/interfaces/ISummary';
import { IGetBookingsAirResponse } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { DatesService } from 'app_sasha/shared/services/dates/dates.service';

//lib
import { faPlane, IconDefinition } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'air-summary-menu',
    template: `
        <div>
            <div>
                <i class="fa label-icon fa-plane"></i>
                <fa-icon [icon]="iconPlane" class="label-icon"></fa-icon>
                <span>{{ dates.begin }}</span>
            </div>
            <directions [from]="sector.from" [to]="sector.to" [begin]="sector.begin" [end]="sector.end"></directions>
        </div>
    `,
    styles: [`
        .label-icon {
            margin-right: .75rem;
        }

        directions ::ng-deep .date, directions ::ng-deep .code {
            margin: 0;
        }
    `]
})
export class AirSummaryMenuComponent implements OnChanges {
    @Input()
    public booking: IGetBookingsAirResponse;

    @Input()
    public sector: ISummarySectorAir;

    public dates: {
        begin: string;
    };

    public iconPlane: IconDefinition = faPlane;

    constructor(
        private readonly datesService: DatesService
    ) {}

    public ngOnChanges(): void {
        this.dates = {
            begin: this.datesService.formatDate(this.sector.begin, 'momentMedium'),
        };
    }
}
